import { render, staticRenderFns } from "./ModifyDomainRegistrationContactModal.vue?vue&type=template&id=73cccb56&"
import script from "./ModifyDomainRegistrationContactModal.vue?vue&type=script&lang=js&"
export * from "./ModifyDomainRegistrationContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports